import React, { useState, useEffect, useRef } from "react"
import '../../assets/css/views/activities/inventory.css'
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Select, Button, Table, TableData, TableColumns, TablePreferences, TableColumnWidth, SelectOption, SelectInterface, ContextualMenu, IconPencil, IconTrash, Modal, ButtonGroup, IconWarningAlt, OptionInterface, TextBox, IconPlus, IconMinus, Card } from "@veneer/core";
import { IUserDto } from "../../models/dto/generalApi/IUserDto";
import appointmentService from "../../services/agendaApi/appointment.service";
import { IAppointmentDto } from "../../models/dto/agendaApi/IAppointmentDto";
import inventoryService from "../../services/agendaApi/inventory.service";
import { IInventoryDto } from "../../models/dto/agendaApi/IInventoryDto";
import { IProductByBrandDto } from "../../models/dto/agendaApi/IProductDto";
import { IInventoryIn } from "../../models/input/agendaApi/IInventoryIn";
import { NumberFormatBase } from 'react-number-format';
import BackButton from "../../features/path/backButton";
import { BreadCrumbsEnum } from "../../models/enum/BreadCrumbsEnum";
import { CountryEnum } from "../../models/enum/CountryEnum";
import { useSelector } from "react-redux";
import { RootState } from "../../app/store";
import { decryptText } from "../../utils/encryptionUtils";




export default function InventoryAppointment() {

    const params = useParams();
    const [t] = useTranslation("global");
    type SelectValue = number | string | boolean; //CHECK

    //Loadings
    const [loadingTableData, setLoadingTableData] = useState(false);

    //Data
    const [tableData, setTableData] = useState<TableData[]>([]);
    const [tableDataFiltered, setTableDataFiltered] = useState<TableData[]>([]);
    const [productData, setProductData] = useState<SelectOption[]>([]);
    const [productUncreatedData, setProductUncreatedData] = useState<SelectOption[]>([]);
    const [productUncreatedDataFiltered, setProductUncreatedDataFiltered] = useState<SelectOption[]>([]);
    const [skuList, setSkuList] = useState<string[]>([]);
    const [appointmentActivityId, setAppointmentActivityId] = useState(NaN);
    const [activityId, setActivityId] = useState(NaN);
    const [country, setCountry] = useState(NaN);
    const actualPosCode = useRef('');



    let tableDataArray: IInventoryDto[];

    interface ICreateInventory {
        productName: SelectValue[],
        warehouse: string,
        displayed: string,
        doa: string,
    }

    interface IModifyValues {
        productName: string,
        sku: string,
        warehouse: string,
        displayed: string,
        doa: string,
    }



    //Selects
    const [createInventoryIn, setCreateInventoryIn] = useState<ICreateInventory[]>([
        {
            'productName': [],
            'warehouse': '',
            'displayed': '',
            'doa': '',

        },

    ]);
    const [modifyValues, setModifyValues] = useState<IModifyValues[]>([
        {
            'productName': '',
            'sku': '',
            'warehouse': '',
            'displayed': '',
            'doa': '',

        },

    ]);
    const [tableDataBrasilFiltered, setTableDataBrasilFiltered] = useState<TableData[]>([]);
    const [productName, setProductName] = useState<SelectValue[]>([]);
    const [warehouse, setWarehouse] = useState<string>();
    const [displayed, setDisplayed] = useState<string>();
    const [doa, setDoa] = useState<string>();
    const [search, setSearch] = useState<string>();
    const [searchModifyValues, setSearchModifyValues] = useState<string>('');


    //Shows
    const [showModalAddInventory, setShowModalAddInventory] = useState(false);
    const [showModalDeleteInventory, setShowModalDeleteInventory] = useState(false);
    const [showModalEditInventory, setShowModalEditInventory] = useState(false);
    const [showModalSubmitConfirmation, setShowModalSubmitConfirmation] = useState(false);



    //Disables
    const [productUncreatedSelectDisable, setProductUncreatedSelectDisable] = useState(true);
    const [addInventoryButtonDisable, setAddInventoryButtonDisable] = useState(true);
    const [editInventoryButtonDisable, setEditInventoryButtonDisable] = useState(true);
    const [modifyValuesButtonDisable, setModifyValuesButtonDisable] = useState(true);


    const state: any = useSelector((state: RootState) => state.user);



    useEffect(() => {
        getTableData()
    }, [])

    useEffect(() => {
        if (productName.length > 0 && warehouse !== '' && displayed !== '' && doa) {
            setEditInventoryButtonDisable(false)
        } else {
            setEditInventoryButtonDisable(true)
        }

    }, [productName, warehouse, displayed, doa])

    useEffect(() => {

        if (createInventoryIn.some(function (item) {
            return item.productName.length === 0 || item.warehouse === '' || item.displayed === '' || item.doa === ''
        })) {
            setAddInventoryButtonDisable(true)
        } else {
            setAddInventoryButtonDisable(false)
        }

    }, [createInventoryIn])

    useEffect(() => {

        if (modifyValues.some(function (item) {
            return item.warehouse === '' || item.displayed === '' || item.doa === '' || item.warehouse === 'null' || item.displayed === 'null' || item.doa === 'null'
        })) {
            setModifyValuesButtonDisable(true)
        } else {
            setModifyValuesButtonDisable(false)
        }

    }, [modifyValues])



    const getTableData = () => {
        //13 user.countryId
        setCountry(Number(decryptText(state.user.countryId)))
        setLoadingTableData(true)
        let id = Number(params.id);
        let activityId = Number(params.activityId);
        setActivityId(id)
        setAppointmentActivityId(activityId);
        appointmentService.getAppointmentByUser()
            .then(r => {
                getPosCode(r, id)
            })
    }


    const getPosCode = (data: IAppointmentDto[], id: number) => {
        let posCode = data.find(x => x.appointmentId === id)?.posCode;
        if (posCode) {
            //BRABIG012  posCode
            actualPosCode.current = posCode;
            getInventory(posCode)
        } else { alert("Error") }
    }


    const getInventory = (posCode: string) => {
        
        inventoryService.getInventory(posCode)
            .then(r => {
                tableDataArray = r;
                //13  user.countryId
                fillDataInventory(r, Number(decryptText(state.user.countryId)))
                fillSkuList(r)
                fillDataProduct(r)
            }).finally(() => setLoadingTableData(false));

    }


    const getUncreatedProducts = () => {
        inventoryService.getProducts(actualPosCode.current, 1)
            .then(r => {
                filterUncreatedProducts(r)
            }).finally(() => setProductUncreatedSelectDisable(false));

    }

    const fillDataProduct = (data: IInventoryDto[]) => {
        const productData: SelectOption[] = [];

        for (let i = 0; i < data.length; i++) {
            const product: IInventoryDto = data[i];
            let selectProductData: SelectOption;
            selectProductData = {
                'value': product.sku,
                'label': product.productName,
            }
            productData.push(selectProductData);
        }
        setProductData(productData);
    }


    const filterUncreatedProducts = (data: IProductByBrandDto[]) => {
        const productUncreatedData: IProductByBrandDto[] = data.filter(function (item) {
            if (skuList.includes(item.sku)) {
            } else {
                return item
            }
        });
        fillDataProductUncreated(productUncreatedData)
    }

    const fillDataProductUncreated = (data: IProductByBrandDto[]) => {
        const productUncreatedData: SelectOption[] = [];

        for (let i = 0; i < data.length; i++) {
            const product: IProductByBrandDto = data[i];
            let selectProductData: SelectOption;
            selectProductData = {
                'value': product.sku,
                'label': product.productName,
            }
            productUncreatedData.push(selectProductData);
        }
        setProductUncreatedData(productUncreatedData);
        setProductUncreatedDataFiltered(productUncreatedData);
    }

    const fillSkuList = (data: IInventoryDto[]) => {
        const skuList: string[] = [];

        for (let i = 0; i < data.length; i++) {
            skuList.push(data[i].sku);
        }
        setSkuList(skuList);
    }

    const fillDataInventory = (data: IInventoryDto[], countryId: number) => {
        if (countryId === CountryEnum.brasil1 || countryId === CountryEnum.brasil2 || countryId === CountryEnum.brasil3) {
            const modifyValuesTemp: IModifyValues[] = [];
            for (let i = 0; i < data.length; i++) {
                const inventory: IInventoryDto = data[i];
                modifyValuesTemp.push({
                    'productName': inventory.productName,
                    'sku': inventory.sku,
                    'warehouse': String(inventory.warehouse),
                    'displayed': String(inventory.displayed),
                    'doa': String(inventory.doa)
                })
            }
            setModifyValues(modifyValuesTemp)

        } else {
            const pagedData: TableData[] = [];
            for (let i = 0; i < data.length; i++) {
                const inventory: IInventoryDto = data[i];
                let tableData: TableData = {};
                tableData = {
                    'posCode': inventory.poS_Code,
                    'sku': inventory.sku,
                    'productName': inventory.productName,
                    'productModel': inventory.productModel,
                    'warehouse': inventory.warehouse,
                    'displayed': inventory.displayed,
                    'doa': inventory.doa,
                    'rowConfig': {
                        action: <ContextualMenu
                            onClick={handleActionRowConfig}
                            options={[
                                { value: inventory.sku, label: t("header.edit"), icon: <IconPencil /> },
                                { value: inventory.sku, label: t("header.delete"), icon: <IconTrash /> },

                            ]}
                            placement="leading"
                        />,
                        disabled: false,
                        noWrap: false,
                        selected: false,

                    }
                }
                pagedData.push(tableData);
            }
            setTableData(pagedData);
            setTableDataFiltered(pagedData);

        }

    }


    const tableDataBrasil: TableData[] = React.useMemo(
        () =>
            modifyValues.map((inventory, i) => {
                return {
                    'sku': inventory.sku,
                    'productName': inventory.productName,
                    'warehouse': String(inventory.warehouse),
                    'displayed': String(inventory.displayed),
                    'doa': String(inventory.doa),
                    'warehouseTextbox': <TextBox
                        className="editInventoryTextboxTable"
                        type="number"
                        onChange={e => handleChangeModifyWarehouse(e, i)}
                        value={modifyValues[i].warehouse}
                        inputComponent={NumberFormatBase}
                    />,
                    'displayedTextbox': <TextBox
                        className="editInventoryTextboxTable"
                        type="number"
                        onChange={e => handleChangeModifyDisplayed(e, i)}
                        value={modifyValues[i].displayed}
                        inputComponent={NumberFormatBase}
                    />,
                    'doaTextbox': <TextBox
                        className="editInventoryTextboxTable"
                        type="number"
                        onChange={e => handleChangeModifyDoa(e, i)}
                        value={modifyValues[i].doa}
                        inputComponent={NumberFormatBase}
                    />
                }

            }),
        [modifyValues]
    );


    useEffect(() => {
        if (searchModifyValues === '') {
            setTableDataBrasilFiltered(tableDataBrasil)
        }

    }, [tableDataBrasil])


    const columns: TableColumns[] = [
        {
            id: 'productName',
            label: t("header.productName"),
        },
        {
            id: 'warehouse',
            label: t("header.warehouse"),
        },
        {
            id: 'displayed',
            label: t("header.displayed"),
        },
        {
            id: 'doa',
            label: t("header.doa"),
        },

    ];

    const columnsWidth: TableColumnWidth[] = [

        {
            columnId: 'productName',
            width: "70%"
        },
        {
            columnId: 'warehouse',
            width: "10%"
        },
        {
            columnId: 'displayed',
            width: "10%"
        },
        {
            columnId: 'doa',
            width: "10%"
        },

    ]

    const tablePreferences: TablePreferences = {
        width: columnsWidth
    }

    const columnsBrasil: TableColumns[] = [
        {
            id: 'productName',
            label: t("header.productName"),
        },
        {
            id: 'warehouseTextbox',
            label: t("header.warehouse"),
        },
        {
            id: 'displayedTextbox',
            label: t("header.displayed"),
        },
        {
            id: 'doaTextbox',
            label: t("header.doa"),
        },

    ];

    const columnsWidthBrasil: TableColumnWidth[] = [

        {
            columnId: 'productName',
            width: "70%"
        },
        {
            columnId: 'warehouseTextbox',
            width: "10%"
        },
        {
            columnId: 'displayedTextbox',
            width: "10%"
        },
        {
            columnId: 'doaTextbox',
            width: "10%"
        },

    ]

    const tablePreferencesBrasil: TablePreferences = {
        width: columnsWidthBrasil
    }



    const resetForm = () => {
        setProductName([]);
        setWarehouse('');
        setDisplayed('');
        setDoa('');
    }


    const handleActionRowConfig = (e: React.SyntheticEvent, option?: OptionInterface) => {
        if (option) {
            if (option.label === "Edit" || option.label === "Editar" || option.label === "Editar") {
                ChargeInfoForEdit(String(option.value))
                setShowModalEditInventory(true);

            } else if (option.label === "Delete" || option.label === "Eliminar" || option.label === "Excluir") {
                ChargeInfoForEdit(String(option.value))
                setShowModalDeleteInventory(true)
            }


        }

    }

    const ChargeInfoForEdit = (sku: string) => {
        let item = tableDataArray.find(x => x.sku == sku);
        if (item) {
            setProductName([item.sku]);
            setWarehouse(String(item.warehouse));
            setDisplayed(String(item.displayed));
            setDoa(String(item.doa));
        }
    }


    const handleChangeWarehouse = (value: string) => {
        setWarehouse(value);
    }
    const handleChangeDisplayed = (value: string) => {
        setDisplayed(value);
    }
    const handleChangeDoa = (value: string) => {
        setDoa(value);
    }

    const handleChangeCreateProductName = (value: SelectValue, index: number) => {
        let createInvetoryTemp = createInventoryIn;
        createInvetoryTemp[index].productName = [value];
        setCreateInventoryIn([...createInvetoryTemp])

    }
    const handleChangeCreateWarehouse = (value: string, index: number) => {
        let createInvetoryTemp = createInventoryIn;
        createInvetoryTemp[index].warehouse = value;
        setCreateInventoryIn([...createInvetoryTemp])
    }
    const handleChangeCreateDisplayed = (value: string, index: number) => {
        let createInvetoryTemp = createInventoryIn;
        createInvetoryTemp[index].displayed = value;
        setCreateInventoryIn([...createInvetoryTemp])
    }
    const handleChangeCreateDoa = (value: string, index: number) => {
        let createInvetoryTemp = createInventoryIn;
        createInvetoryTemp[index].doa = value;
        setCreateInventoryIn([...createInvetoryTemp])
    }

    const handleChangeModifyWarehouse = (value: string, index: number) => {
        const modifyvaluesTemp = modifyValues;
        if (value === '') {
            modifyvaluesTemp[index].warehouse = '';
            setModifyValues([...modifyvaluesTemp])
        } else {
            modifyvaluesTemp[index].warehouse = value;
            setModifyValues([...modifyvaluesTemp])
        }
    }

    const handleChangeModifyDisplayed = (value: string, index: number) => {
        const modifyvaluesTemp = modifyValues;
        if (value === '') {
            modifyvaluesTemp[index].displayed = '';
            setModifyValues([...modifyvaluesTemp])
        } else {
            modifyvaluesTemp[index].displayed = value;
            setModifyValues([...modifyvaluesTemp])
        }
    }

    const handleChangeModifyDoa = (value: string, index: number) => {
        const modifyvaluesTemp = modifyValues;
        if (value === '') {
            modifyvaluesTemp[index].doa = '';
            setModifyValues([...modifyvaluesTemp])
        } else {
            modifyvaluesTemp[index].doa = value;
            setModifyValues([...modifyvaluesTemp])
        }
    }

    const handleChangeSearch = (value: string) => {
        setSearch(value);
        const filterArray = tableData.filter((element) => {
            if (element.productName.toString().toLowerCase().includes(String(value).toLowerCase()) || element.sku.toString().toLowerCase().includes(String(value).toLowerCase())) {
                return element;
            }
        });
        setTableDataFiltered(filterArray)
    }

    const handleChangeSearchBrasil = (value: string) => {
        setSearchModifyValues(value);
        const filterArray = tableDataBrasil.filter((element) => {
            if (element.productName.toString().toLowerCase().includes(String(value).toLowerCase()) || element.sku.toString().toLowerCase().includes(String(value).toLowerCase())) {
                return element;
            }
        });
        setTableDataBrasilFiltered(filterArray)
    }



    const handleSelectSearch = (valueSearch: string) => {

        const filterArray = productUncreatedData.filter((element) => {
            if (String(element.value).toLowerCase().includes(String(valueSearch).toLowerCase()) || String(element.label).toLowerCase().includes(String(valueSearch).toLowerCase())) {
                return element;
            }
        });
        setProductUncreatedDataFiltered(filterArray)

    }

    const onClearCreateProductName = (index: number) => {
        let createInvetoryTemp = createInventoryIn;
        createInvetoryTemp[index].productName = [];
        setCreateInventoryIn([...createInvetoryTemp])

    }


    const onAddInventory = () => {
        getUncreatedProducts()
        setShowModalAddInventory(true)
    }


    const submitInventory = () => {

        let inventoryIn: IInventoryIn[] = []

        createInventoryIn.forEach(item => {
            inventoryIn.push({
                appointmentActivityID: appointmentActivityId,
                sku: String(item.productName),
                warehouse: Number(item.warehouse),
                displayed: Number(item.displayed),
                doa: Number(item.doa),
                deleted: 0

            })
        })


        inventoryService.insertInventory(inventoryIn)
            .then(r => {
                setShowModalAddInventory(false);
                setCreateInventoryIn([
                    {
                        'productName': [],
                        'warehouse': '',
                        'displayed': '',
                        'doa': '',

                    },

                ]);
                getTableData()
            })

    }

    const cancelAddInventory = () => {
        setShowModalAddInventory(false);
        setProductUncreatedData([]);
        setProductUncreatedDataFiltered([]);
        setCreateInventoryIn([
            {
                'productName': [],
                'warehouse': '',
                'displayed': '',
                'doa': '',

            },

        ]);
    }


    const deleteInventory = () => {

        let inventoryIn: IInventoryIn = {
            appointmentActivityID: appointmentActivityId,
            sku: String(productName),
            warehouse: Number(warehouse),
            displayed: Number(displayed),
            doa: Number(doa),
            deleted: 1

        }
        inventoryService.insertInventory([inventoryIn])
            .then(r => {
                setShowModalDeleteInventory(false);
                getTableData()
            })


    }

    const cancelDeleteInventory = () => {
        setShowModalDeleteInventory(false);
    }

    const submitEditInventory = () => {

        let inventoryIn: IInventoryIn = {
            appointmentActivityID: appointmentActivityId,
            sku: String(productName),
            warehouse: Number(warehouse),
            displayed: Number(displayed),
            doa: Number(doa),
            deleted: 0

        }
        inventoryService.insertInventory([inventoryIn])
            .then(r => {
                setShowModalEditInventory(false);
                resetForm();
                getTableData()
            })


    }

    const cancelEditInventory = () => {
        setShowModalEditInventory(false);
        resetForm()

    }

    const AddProduct = () => {
        let createInvetoryTemp = createInventoryIn;
        createInvetoryTemp.push({
            'productName': [],
            'warehouse': '',
            'displayed': '',
            'doa': '',

        },)

        setCreateInventoryIn([...createInvetoryTemp])


    }

    const DeleteProduct = (index: number) => {
        let createInvetoryTemp = createInventoryIn;
        createInvetoryTemp.splice(index, 1);
        setCreateInventoryIn([...createInvetoryTemp])

    }


    const submitModifyValues = () => {

        let inventoryIn: IInventoryIn[] = []

        modifyValues.forEach(item => {
            inventoryIn.push({
                appointmentActivityID: appointmentActivityId,
                sku: String(item.sku),
                warehouse: Number(item.warehouse),
                displayed: Number(item.displayed),
                doa: Number(item.doa),
                deleted: 0

            })
        })


        inventoryService.insertInventory(inventoryIn)
            .then(r => {
                setModifyValues([
                    {
                        'productName': '',
                        'sku': '',
                        'warehouse': '',
                        'displayed': '',
                        'doa': '',

                    },

                ]);
                setSearchModifyValues('')
                getTableData()
                setShowModalSubmitConfirmation(false)
            })

    }



    return (
        <>
            {
                (() => {
                    if (Number.isNaN(country)) {
                        return (<div></div>)
                    }
                    else if (country === CountryEnum.brasil1 || country === CountryEnum.brasil2 || country === CountryEnum.brasil3) {
                        return (
                            <div className="inventory">
                                <BackButton route={BreadCrumbsEnum.Inventory} activityId={activityId} appointmentActivityId={appointmentActivityId} />
                                <h4 className="inventoryTitle">{t("header.inventory")}</h4>

                                <div className="inventoryDivTop">
                                    <TextBox
                                        className="searchInventoryTextbox"
                                        label={t("header.search")}
                                        type="search"
                                        onChange={handleChangeSearchBrasil}
                                        value={searchModifyValues}
                                    />

                                    <Button disabled={modifyValuesButtonDisable} onClick={() => setShowModalSubmitConfirmation(true)}>{t("modal.saveTitleInfo")}</Button>
                                </div>


                                <Card
                                    appearance="outlined"
                                    className="inventoryDivTable"
                                    content={<Table
                                        className="inventoryTable"
                                        behavior={{
                                            type: 'singlePage',
                                        }}
                                        columnResize
                                        preferences={tablePreferencesBrasil}
                                        loading={loadingTableData}
                                        columns={columnsBrasil}
                                        data={tableDataBrasilFiltered}
                                        loadingDataLength={10}
                                        customNoItems={<div className="customNoItems"><div className="DivIconCustomNoItems"><IconWarningAlt className="IconCustomNoItems" /></div>{t("header.noItemsFound")}</div>}
                                    />}
                                />


                                <div style={{ position: 'relative' }}>
                                    <Modal
                                        align="center"
                                        id="modalSubmitConfirmation"
                                        show={showModalSubmitConfirmation}
                                        onClose={() => setShowModalSubmitConfirmation(false)}
                                        footer={(
                                            <ButtonGroup className="submitConfirmationButtongrouop">
                                                <Button onClick={submitModifyValues}>{t("header.yes")}</Button>
                                                <Button onClick={() => setShowModalSubmitConfirmation(false)} appearance="secondary">{t("header.cancel")}</Button>
                                            </ButtonGroup>
                                        )}
                                        title={t("modal.saveTitleInfo")}
                                    >
                                        <p>
                                            {t("modal.saveMessage")}
                                        </p>
                                    </Modal>
                                </div>

                            </div>
                        )

                    } else {
                        return (
                            <div className="inventory">
                                <BackButton route={BreadCrumbsEnum.Inventory} activityId={activityId} appointmentActivityId={appointmentActivityId} />
                                <h4 className="inventoryTitle">{t("header.inventory")}</h4>

                                <div className="inventoryDivTop">
                                    <TextBox
                                        className="searchInventoryTextbox"
                                        label={t("header.search")}
                                        type="search"
                                        onChange={handleChangeSearch}
                                        value={search}
                                    />
                                    <Button onClick={onAddInventory}>{t("header.addProducts")}</Button>

                                </div>
                                <Card
                                    appearance="outlined"
                                    className="inventoryDivTable"
                                    content={<Table
                                        className="inventoryTable"
                                        behavior={{
                                            type: 'singlePage',
                                        }}
                                        columnResize
                                        preferences={tablePreferences}
                                        loading={loadingTableData}
                                        columns={columns}
                                        data={tableDataFiltered}
                                        loadingDataLength={10}
                                        customNoItems={<div className="customNoItems"><div className="DivIconCustomNoItems"><IconWarningAlt className="IconCustomNoItems" /></div>{t("header.noItemsFound")}</div>}
                                    />}
                                />


                                <div style={{ position: 'relative' }}>
                                    <Modal
                                        className="modalCreateInventory"
                                        closeButton={true}
                                        align="center"
                                        id="modalAddInventory"
                                        show={showModalAddInventory}
                                        onClose={cancelAddInventory}
                                        footer={(
                                            <ButtonGroup className="createInventoryButtongrouop">
                                                <Button disabled={addInventoryButtonDisable} onClick={submitInventory} >{t("header.submit")}</Button>
                                                <Button onClick={cancelAddInventory} appearance="secondary">{t("header.cancel")}</Button>
                                            </ButtonGroup>
                                        )}
                                        title={t("header.addProducts")}
                                    >

                                        <div className="createInventoryAll">

                                            {createInventoryIn.map(function (item, index) {
                                                return (
                                                    <div className="createInventory">
                                                        <Select
                                                            className="createInventorySelect"
                                                            label={t("header.productName")}
                                                            onChange={e => handleChangeCreateProductName(e.value, index)}
                                                            options={productUncreatedDataFiltered}
                                                            value={item.productName}
                                                            onClear={() => onClearCreateProductName(index)}
                                                            disabled={productUncreatedSelectDisable}
                                                            placement="bottom-start"
                                                            onSearch={handleSelectSearch}
                                                            showSearch
                                                        />
                                                        <div className="createInventoryTextboxes">
                                                            <TextBox
                                                                className="createInventoryTextbox"
                                                                label={t("header.warehouse")}
                                                                type="number"
                                                                onChange={e => handleChangeCreateWarehouse(e, index)}
                                                                value={item.warehouse}
                                                                inputComponent={NumberFormatBase}

                                                            />
                                                            <TextBox
                                                                className="createInventoryTextbox"
                                                                label={t("header.displayed")}
                                                                type="number"
                                                                onChange={e => handleChangeCreateDisplayed(e, index)}
                                                                value={item.displayed}
                                                                inputComponent={NumberFormatBase}

                                                            />
                                                            <TextBox
                                                                className="createInventoryTextbox"
                                                                label={t("header.doa")}
                                                                type="number"
                                                                onChange={e => handleChangeCreateDoa(e, index)}
                                                                value={item.doa}
                                                                inputComponent={NumberFormatBase}

                                                            />
                                                            <div className="createInventoryButtons">
                                                                <Button className="createInventoryButton" onClick={AddProduct} leadingIcon={<IconPlus />} ></Button>
                                                                {index === 0 ? null : <Button className="createInventoryButton" onClick={() => DeleteProduct(index)} leadingIcon={<IconMinus />} ></Button>}
                                                            </div>

                                                        </div>

                                                    </div>
                                                )
                                            })
                                            }
                                        </div>

                                    </Modal>
                                </div>

                                <div style={{ position: 'relative' }}>
                                    <Modal
                                        align="center"
                                        id="modalDeleteInventory"
                                        show={showModalDeleteInventory}
                                        onClose={cancelDeleteInventory}
                                        footer={(
                                            <ButtonGroup className="deleteInventoryButtongrouop">
                                                <Button onClick={deleteInventory}>{t("header.yes")}</Button>
                                                <Button onClick={cancelDeleteInventory} appearance="secondary">{t("header.cancel")}</Button>
                                            </ButtonGroup>
                                        )}
                                        title={t("header.deleteItem")}
                                    >
                                        <p>
                                            {t("header.questionDelete")}
                                        </p>
                                    </Modal>
                                </div>

                                <div style={{ position: 'relative' }}>
                                    <Modal
                                        closeButton={true}
                                        align="center"
                                        id="modalEditInventory"
                                        show={showModalEditInventory}
                                        onClose={cancelEditInventory}
                                        footer={(
                                            <ButtonGroup className="editInventoryButtongrouop">
                                                <Button disabled={editInventoryButtonDisable} onClick={submitEditInventory} >{t("header.submit")}</Button>
                                                <Button onClick={cancelEditInventory} appearance="secondary">{t("header.cancel")}</Button>
                                            </ButtonGroup>
                                        )}
                                        title={t("header.editInventory")}
                                    >
                                        <div className="editInventory">
                                            <Select
                                                className="editInventorySelect"
                                                label={t("header.productName")}
                                                options={productData}
                                                value={productName}
                                                readOnly
                                            />
                                            <TextBox
                                                className="editInventoryTextbox"
                                                label={t("header.warehouse")}
                                                type="number"
                                                onChange={handleChangeWarehouse}
                                                value={warehouse}
                                                inputComponent={NumberFormatBase}
                                            />
                                            <TextBox
                                                className="editInventoryTextbox"
                                                label={t("header.displayed")}
                                                type="number"
                                                onChange={handleChangeDisplayed}
                                                value={displayed}
                                                inputComponent={NumberFormatBase}
                                            />
                                            <TextBox
                                                className="editInventoryTextbox"
                                                label={t("header.doa")}
                                                type="number"
                                                onChange={handleChangeDoa}
                                                value={doa}
                                                inputComponent={NumberFormatBase}
                                            />
                                        </div>
                                    </Modal>
                                </div>

                            </div>
                        )
                    }
                })()
            }

        </>


    );
}